import { TunnelNavigationStore } from '../../../stores/tunnel/tunnel-navigation.store';
import { Subscription } from 'rxjs';
import { Injectable, OnDestroy, OnInit } from '@angular/core';
import { TunnelDataStore } from '../../../stores/tunnel/tunnel-data.store';

@Injectable({
  providedIn: 'root',
})
export abstract class BaseTunnelObject implements OnInit, OnDestroy {
  protected subscriptionList: Subscription[] = [];

  constructor(
    protected tunnelNavigationStore: TunnelNavigationStore,
    protected tunnelDataStore: TunnelDataStore
  ) {}

  ngOnInit() {
    this.subscribeToObservable();
  }

  ngOnDestroy() {
    this.unsubscribeToObservable();
  }

  protected abstract subscribeToObservable();

  protected unsubscribeToObservable() {
    this.subscriptionList?.forEach(sub => sub.unsubscribe());
  }
}
